import _ from 'lodash';

export const apiHelpers = {
  getGhinCard: (golferNumber, golferClub) => getGhinCard(golferNumber, golferClub),
  getMpResults: (date, sportsModeSport, _sportsModeKey, callback) => getMpResults(date, sportsModeSport, _sportsModeKey, callback),
  getScorecard: (fn_cls, courseNumber) => getScorecard(fn_cls, courseNumber),
  getUrlData: (url, setFecthData, handleError) => getUrlData(url, setFecthData, handleError),
}

const getUrlData = async (url, setFecthData, handleError) => {

  let trueUrl;

  switch (url) {
    case 'https://www.hilton.com':
      trueUrl = 'https://www.hilton.com/en/search/hilton-honors/?query=Pittsburgh,%20Pennsylvania,%20US&placeId=&arrivalDate=2021-04-20&departureDate=2021-04-21&flexibleDates=false&numRooms=1&numAdults=1&numChildren=0&specialRateTokens=&awc=&cid=&dclid=&gclid=&wtmcid=&sessionToken=d8471644-0332-44ac-a0e3-c7ea76dce08b'
      break;
    default:
      trueUrl = ''
  }

  const urlDataF = { url: trueUrl }

  return await fn_cls.fetchTableData(fsCall, urlDataF, setFecthData, handleError).then(response_data => {

    const { result } = response_data

    const parser = new DOMParser()
    const doc = parser.parseFromString(result, 'text/html')

    switch (url) {
      case 'http://techsummit.nba.com/participants/':
        const divs = doc.querySelectorAll('div')
        const participants = []
        if (divs) {
          divs.forEach(div => {
            const details = div.querySelectorAll('.details')
            const summary = div.querySelectorAll('.summary')
            const figure = div.querySelectorAll('figure')
            if (details.length === 1) {
              const detail = details[0]
              const n = detail.querySelectorAll('h5')[0].innerText.toString()
              const ns = n.split(' ')
              const participant = {
                // name: detail.querySelectorAll('h5')[0].innerText.toString(),
                firstName: ns[0],
                lastName: ns[1],
                title: detail.querySelectorAll('.participant-position')[0].innerText.toString(),
                company: detail.querySelectorAll('.participant-affiliation')[0].innerText.toString(),
              }


              if (summary.length === 1) {
                const summ = summary[0]
                const inner = summ.querySelectorAll('.inner')
                if (inner.length === 1) {
                  const inn = inner[0]
                  const ps = inn.querySelectorAll('p')
                  let _ddd = ''
                  if (ps) {
                    ps.forEach(p => {
                      if (!p.className) {
                        _ddd += p.innerText.toString().trim() + '. '
                      }
                    })
                  }
                  participant.description = _ddd
                }
              }

              if (figure && figure.length === 1) {
                const fig = figure[0]
                const spani = fig.querySelectorAll('span')
                if (spani && spani.length === 1) {
                  const si = spani[0]
                  participant.imageUrl = si.style.backgroundImage.slice(4, -1).replace(/"/g, "")
                }
              }
              participants.push(participant)
            }
          })
        }
        return participants

      case 'http://techsummit.nba.com/event-schedule/':
        const main = doc.querySelectorAll('main')
        const m = main[0]
        m.childNodes.forEach(cn => {
          if (cn && cn.childNodes) {
            cn.childNodes.forEach(cnn => {
              console.log('cnn', cnn)
            })
          }
        })
        break;

      case 'https://www.hilton.com':
        console.log(doc.querySelectorAll('body'))
        console.log(doc.querySelectorAll('main'))
        console.log(doc.querySelectorAll('ul'))

        const uls = doc.querySelectorAll('ul')
        uls.forEach(ul => {
          console.log('ul', ul.innerText)
        })

        // const divz = docE.querySelectorAll('body')
        // if (divz && divz.length > 0) {
        //   divz.forEach(div => {
        //     const uls = div.querySelectorAll('ul')
        //     if (uls)
        //       uls.forEach(ul => {
        //         const lis = ul.querySelectorAll('li')
        //         if (lis) {
        //           lis.forEach(lii => {
        //             const divs = lii.querySelectorAll('div')
        //             if (divs) {
        //               divs.forEach(div => {
        //                 console.log('div', div.innerText)
        //               })
        //             }
        //           })
        //         }
        //       })
        //   }) 
        // }

        // const mainmd = docE.querySelectorAll('body')
        // console.log('mainmd', mainmd)
        // const mainm = doc.querySelectorAll('body') 
        // const mm = mainm[0]
        // console.log('mm', mm)
        break;
      default:
      // notohing
    }
  })
}

const getScorecard = async (fn_cls, courseNumber) => {

  const urlDataF = { url: 'https://freegolftracker.com/courses/' + courseNumber + '.htm' }

  console.log('urlDataF', urlDataF)

  const response_data = await fn_cls.fetchTableData(urlDataF)

  console.log('response_data', response_data)

  try {
    const { result } = response_data ?? {}

    const parser = new DOMParser()
    const doc = parser.parseFromString(result, 'text/html')
    const divs = doc.querySelectorAll('div')
    const tables = doc.querySelectorAll('table')

    const cn = divs[15]
    const hhh = cn.querySelectorAll('h3')

    const course = { name: hhh[0].innerText.trim() }
    const teeBoxes = {}
    const holes = {}

    addCourseInfo(course, tables[0], 0)
    addTeeBoxInfo(teeBoxes, tables[1], 0)
    addHoles(holes, tables[2], 0)
    addHoles(holes, tables[3], 9)

    course.teeBoxes = teeBoxes
    course.holes = holes

    return course
  } catch (error) {
    return {}
  }
}

const getGhinCard = async (golferNumber, golferClub) => {

  const urlDataF = { url: 'https://www.ghin.com/golfer-lookup/golfer/53616c7465645f5f88ae437a11578edfeaf0586f451f61fd469e185d906729e5/club/22178' }
  // const urlDataF = { url: 'https://www.ghin.com/golfer-lookup/golfer/11527703/club/22178' }

  // https://api2.ghin.com/api/v1/golfers.json

  const fromGhin = true
  const perPage = 25

  const statusActive = { status: 'active' }
  const url = 'https://api2.ghin.com/api/v1/golfers.json'

  const sortByFullName = {
    order: "asc",
    sorting_criteria: "full_name"
  }

  const extraParams = {
    golfer_id: "11527703"
  }

  let params = new URLSearchParams({
    ...statusActive,
    ...fromGhin,
    ...perPage,
    ...sortByFullName,
    page: 1,
    state: 'PA',
  });

  if (extraParams) {
    params = { ...params, ...extraParams };
  }


  fetch(`${url}?${objToQuerystring(params)}`)
    .then(res => {
      console.log('res', res)
      if (!res.ok) {
        throw Error('errors')
      }
      return res.json
    })
    .then(data => {
      console.log('data', data)
    })
    .catch(err => {
      console.log('err', err)
    })

  // return await fsfn_srapeUrl(urlDataF).then(response_data => {

  //   const { result } = response_data ?? {}
  //   const parser = new DOMParser()
  //   const doc = parser.parseFromString(result, 'text/html')
  //   console.log(doc);
  //   const root = doc.querySelectorAll('#root')

  //   if (root) {
  //     root.forEach(item => {
  //       const score = item.querySelectorAll('.info')
  //       console.log('score', score)
  //     })
  //   }
  // }).then(res => {
  //   return res
  // }).catch(error => {
  //   return {}
  // })
}

const getMpResults = async (date, sportsModeSport, _sportsModeKey, callback) => {

  const urlDataF = { url: 'https://www.maxpreps.com/pa/dma/pittsburgh/' + sportsModeSport + '/scores/?date=' + date + '&dmaid=0c9d3fe7-e91a-4cc6-88af-9ae9cbb5e6e5' }

  return await fn_cls.fetchTableData(urlDataF).then(response_data => {

    const { result } = response_data ?? {}

    const parser = new DOMParser()
    const doc = parser.parseFromString(result, 'text/html')

    const selectors = {
      doc: doc,
      uls: doc.querySelectorAll('ul.teams'),
    }

    const mpData = []

    if (selectors.uls) {
      selectors.uls.forEach(ul => {
        const match = {}
        const m = ul.querySelectorAll('li')
        m.forEach((mk, index) => {
          const _score = mk.querySelectorAll('div.score')
          const _name = mk.querySelectorAll('div.name')
          const _nameR = _name && _name[0] ? _name[0].innerText.replace(/.*\)/, '') : null
          switch (index) {
            case 0:
              match.away = _nameR ? _nameR : null
              match.awayScore = _score && _score[0] ? _score[0].innerText : null
              break;
            case 1:
              match.home = _nameR ? _nameR : null
              match.homeScore = _score && _score[0] ? _score[0].innerText : null
              break;
            default:
          }
        })
        mpData.push(match)
      })
    }
    callback(mpData)
  }).then(res => {
    return res
  }).catch(error => {
    console.log('error', error)
    return {}
  })
}

const addCourseInfo = (course, table) => {
  const trs = table.querySelectorAll('tr')
  trs.forEach((tr, index) => {
    const tds = tr.querySelectorAll('td')
    if (tds[1].innerText) {
      course[_.camelCase(tds[0].innerText.toString())] = tds[1].innerText.trim()
    }
  })
}

const addTeeBoxInfo = (teeBoxes, table) => {
  const trs = table.querySelectorAll('tr')
  trs.forEach((tr, rowIndex) => {
    if (rowIndex > 0) {
      const tds = tr.querySelectorAll('td')
      teeBoxes[_.camelCase(tds[0].innerText.toString())] = {
        slope: tds[1].innerText.trim(),
        rating: tds[2].innerText.trim()
      }
    }
  })
}

const addHoles = (holes, table, added) => {

  const trs = table.querySelectorAll('tr')
  const holeHeaders = []

  // get the headers
  trs.forEach((tr, index) => {
    if (index === 0) {
      const columns = tr.querySelectorAll('td')
      columns.forEach((td, columnIndex) => {
        holeHeaders.push(td.innerText)
        if (columnIndex > 0 && columnIndex <= 9) {
          const trueHoleIndex = columnIndex + added
          if (trueHoleIndex >= 1 && trueHoleIndex <= 18) {
            holes[trueHoleIndex] = {
              holeNumber: trueHoleIndex
            }
          }
        }
      })
    }
  })

  trs.forEach((tr, rowIndex) => {
    // loop the other rows
    if (rowIndex > 0) {
      const columns = tr.querySelectorAll('td')
      const prop = _.camelCase(columns[0].innerText)
      holeHeaders.forEach((hh, columnIndex) => {
        if (columnIndex > 0 && columnIndex <= 9) {
          const trueHoleIndex = columnIndex + added
          if (trueHoleIndex > 0 && trueHoleIndex <= 18) {
            if (columns[columnIndex].innerText) {
              holes[hh][prop] = columns[columnIndex].innerText.trim()
            }
          }
        }
      })
    }
  })
}


export const objToQuerystring = (obj) =>
  Object.entries(obj)
    .map((pair) => pair.map(encodeURIComponent).join("="))
    .join("&");